<template>
  <div>
    <v-data-calendar
      :eventTemplate="eventTemplate"
      :curDate="serviceDate"
      :data-object="data_object"
      :getQry="getQry"
      :getEventColor="getEventColor"
      :key="calKey"
      :eventClick="eventClick"
      calHeight="77vh"
      defaultType="month"
      v-if="calendarReady"
      :filter="calendarFilter"
      ref="calendar"
    >
    </v-data-calendar>
    <!-- <d-calendar
      :objectData="objectData"
      :resourceData="resourceData"
      :eventTemplate="eventTemplate"
      :updateResource="updateResource"
      :resourceObjectName="resourceObjectName"
      :addResourceCaption="addResourceCaption"
      :allResources="allCrew"
      :removeAllResourcesCaption="removeAllResourcesCaption"
      :copyResourcesCaption="copyResourcesCaption"
      :newResourceDialogCaption="crewDialogCaption"
      :applyCopied="applyCopiedCrews"
      :eventClick="openShipment"
      :createMapData="createMapData"
      :onMapMount="onMapMount"
    ></d-calendar> -->
    <!--  -->
    <!-- <v-scheduler
      :objectData="objectData"
      :eventTemplate="eventTemplate"
    ></v-scheduler> -->
  </div>
</template>

<script>
import Vue from "vue";
import * as fun from "../plugins/common";
import * as here from "../plugins/here";
import VueAxios from "vue-axios";
import axios from "axios";

// import * as here from "../plugins/here";
Vue.use(VueAxios, axios);

export default {
  name: "JobSchedule",
  components: {
    VDataCalendar: () => import("../components/DataCalendar.vue")
    // DCalendar: () => import("../components/UI/Calendar.vue"),
    // VScheduler: () => import("../components/Scheduler.vue"),
  },
  props: {},
  data() {
    return {
      calendarReady: true,
      calKey: 0,
      defaultEventColor: "#137C15FF",

      data_object: {
        object_name: "v_schedule",
        date_fields: ["date"],
        mobileBreakpoint: 0,
        id_fields: ["agent_id"],
        get_table: "all",
        additional_data: [{ obj_name: "service_type" }],

        item_key: "shipment_id",
        table_title: "Shipments",
        hasSearch: true
      },
      eventTemplate: function(e) {
        var eventColor = e.color;
        if (e.customer && e.customer.address) {
          var address = "",
            origin,
            destination,
            ev,
            serviceDate;
          origin = e.customer.address.filter(f => {
            return f.address_type == "origin";
          })[0];
          destination = e.customer.address.filter(f => {
            return f.address_type == "destination";
          })[0];
          if (origin && origin.location) {
            address +=
              origin.location.address.geo.location.address.city +
              ", " +
              origin.location.address.geo.location.address.stateCode;
          }
          if (destination && destination.location) {
            address +=
              " to " +
              destination.location.address.geo.location.address.city +
              ", " +
              destination.location.address.geo.location.address.stateCode;
          }
        }

        serviceDate = new Date(e.service_date);

        // var endTime = serviceDate.addHours(1);
        var end = new Date(e.service_date);
        end.setHours(end.getHours() + 2);
        ev = {
          name: e.shipment_id + " " + address,
          start: serviceDate,
          end: end,
          color: eventColor,
          shipment_id: e.shipment_id,
          first_name: e.first_name,
          last_name: e.last_name,
          agent_id: e.agent_id,
          timed: true
        };

        return ev;
      },
      resourceData: {
        object_name: "crew",
        date_fields: ["crew_date"],
        resource_date: "crew_date"
      },
      resourceObjectName: "crew",
      addResourceCaption: "Add Crew",
      removeAllResourcesCaption: "Remove All Crews",
      copyResourcesCaption: "Copy Crew",
      crewDialogCaption: "New Crew",
      objectData: {
        object_name: "schedule",

        aggregate: {
          local_collection: "schedule",
          foreign_collection: "shipment",
          local_field: "sid",
          foreign_field: "_id",
          name: "schedule_data",
          date_fields: ["service_date"],
          // $sort: { "$shipment_stop.stop_number": 1 },
          addFields: {
            service_date: {
              // $toDate: "$service_date",
              // $toDate: "$service_date",
              $dateFromString: {
                dateString: "$service_date",
                format: "%m/%d/%Y %H:%M",
                onError: null
              }
            }
          },
          select_fields: {
            _id: "$_id",
            shipment_id: "$shipment_id",
            first_name: "$customer.contact.first_name",
            last_name: "$customer.contact.last_name",
            shipment_stop: "$shipment_stop",
            locations: "$locations",

            address: "$customer.address",
            service_id: "$service_id",
            estimate_key: "$estimate_key",
            estimate: "$estimate",
            resource: "$foreman",
            resource_id: "$cid",

            // destination_address: "$addresses.destination.address.address",
            // comments: "$comments",
            service_date: "$service_date",
            service_type: "$service_type"
          }
        },

        additional_data: [{ obj_name: "service_type" }, { obj_name: "company" }]
      },
      events: []
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    showDate() {
      this.serviceDate = new Date(this.$refs.calendar.model);
      this.getQry();
    },
    getQry(v) {
      // if (this.dispatchType != "ld-pickup") {
      //   return;
      // }
      var startDate, endDate;
      if (!v) {
        v = this.serviceDate;
      }

      if (v) {
        if (v.startDate) {
          var start = fun.ignoreTimeZone(new Date(v.startDate));

          startDate = new Date(start.setDate(start.getDate() - 1));

          var end = fun.ignoreTimeZone(new Date(v.endDate));

          endDate = new Date(end.setDate(end.getDate() + 1));
        }
      }

      if (startDate && endDate) {
        this.data_object.qry.service_date = {
          $gte: fun.formatDate(startDate, true),
          $lt: fun.formatDate(endDate, true)
        };
      }

      return this.data_object;
    },
    eventClick: function(item) {
      this.$root.addResentTab(item.event);
    },
    getEventColor(event) {
      return event.color || this.defaultEventColor;
    },
    calendarFilter(c) {
      c.events = c.originalEvents.filter(e => {
        return this.curAgent
          ? e.itinerary.filter(i => {
              return i.agent && i.agent._id == this.curAgent;
            }).length
          : true;
      });
      // c.events = c.originalEvents.filter((e) => {
      //   return this.curAgent ? e.agent_id == this.curAgent : true;
      // });
    },
    onMapMount() {
      var that = this;
      Window.prototype.openShipment = function(id, first_name, last_name) {
        var item = {
          shipment_id: id,
          first_name: first_name,
          last_name: last_name
        };
        that.$root.addResentTab(item);
      };
      // var openShipment = function() {
      //   var attribute = this.getAttribute("data-id");
      //   alert(attribute);
      // };
      // return openShipment;
      // var link = document.getElementsByClassName("description-link");
      // for (var i = 0; i < link.length; i++) {
      //   link[i].addEventListener("click", openShipment, true);
      // }
    },
    getMarker(i, service) {
      var label, color;

      if (i == 0) {
        label = "P";
      } else {
        label = "D";
      }
      color = "red";

      var svgMarkup =
        '<svg width="24" height="24" ' +
        'xmlns="http://www.w3.org/2000/svg">' +
        '<rect stroke="white" fill="' +
        color +
        '" x="1" y="1" width="22" ' +
        'height="22" /><text x="12" y="18" font-size="12pt" ' +
        'font-family="Arial" font-weight="bold" text-anchor="middle" ' +
        'fill="white">' +
        label +
        "</text></svg>";

      return svgMarkup;
    },
    getService(model) {
      var estimate = model.estimate[model.estimate_key];
      var service = null;
      estimate.shipment_service.forEach(s => {
        if (s._id == model.service_id) {
          service = s;
        }
      });
      return service;
    },

    createMapData(e, color, defaultSettings) {
      var service = fun.getObjects(e, "_id", e.service_id)[0];
      if (service.shipment_stop.length) {
        var startTime = new Date(service.shipment_stop[0].date_time);
        var endTime = null;
        if (service.drivingTime) {
          startTime.addHours(service.drivingTime);
        }
        if (!service.type_of_distance) {
          service.shipment_stop = service.shipment_stop.sort((a, b) => {
            return a.stop_number - b.stop_number;
          });
          service.shipment_stop.forEach(s => {
            if (s.address_label) {
              var loc = e.address.filter(a => {
                return a.address_type == s.address_label;
              });
              if (loc.length) {
                s.location = loc[0].location;
              }
            }
          });

          service.type_of_distance = here.getMoveType(service, defaultSettings);
        }
        if (service.type_of_distance != "local") {
          if (service.route && service.route.waypoint) {
            service.route.waypoint = [service.route.waypoint[0]];
            service.route.shape = null;
          }
        }
      }
      var s = {};
      s.service_date = service.service_date;
      s.label = service.service_type;
      s.resource = e.resource;
      s.route = {};
      if (service.route && service.route.waypoint) {
        s.route.waypoint = service.route.waypoint;
      }
      if (service.route) {
        s.route.shape = service.route.shape;
      }

      var mapLine = {
        label: service.service_type,
        color: color,
        startTime: startTime,
        endTime: endTime,
        service: s
        // route: service.route,
      };

      return mapLine;
      // }
    },
    openShipment(ev) {
      var item = ev.event.data;
      this.$root.addResentTab(item);
    },

    applyCopiedCrews(d, date, res) {
      d.model.forEach(c => {
        c.crew_date = date;
        delete c._id;
        delete c.crew_id;
      });

      var data = {
        metadata: {
          object_name: "crew"
        },
        records: d.model
      };
      axios.post(this.serverURL + "/add_records", data).then(response => {
        res(response);
      });
    },
    allCrew(name, crew) {
      var myCrew = null;
      crew.forEach(c => {
        var exist = c.crew_employee.filter(e => {
          return e.employee.company == name;
        });
        if (exist.length) {
          myCrew = c;
        }
      });
      var emplList = [];
      if (myCrew) {
        emplList = myCrew.crew_employee.filter(e => {
          return e.employee.company != name;
        });
      }
      var curCrew = "";
      emplList.forEach(e => {
        curCrew += e.employee.company + " (" + e.employee_role + ")<br>";
      });
      return curCrew;
    }
  }
};
</script>

<style lang="css">
.description-link {
  color: white !important;
  cursor: pointer;
}
</style>
